import React from 'react';

import grey from '@material-ui/core/colors/grey';

const FilterDivider = () =>
  <div style={{
    alignSelf: 'center',
    width: '2px',
    height: '25px',
    margin: '10px 5px',
    background: grey[300],
    }}
  />

export default FilterDivider;



// WEBPACK FOOTER //
// ./src/components/core/Filter/FilterDivider.jsx